export default class LinkOption {
    constructor(SmoothScroll) {
        //ページ内慣性スクロール
        var scroll = new SmoothScroll('a[href*="#"]', {
            header: '[data-scroll-header]',
        });


        //idリンク
        const headerHeight = document.querySelector("header").clientHeight;
        // setTimeout(function(){
        //     scrollBy(0, headerHeight * -1);
        // },10)
        console.log("header高さ", headerHeight);
    }
}